import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import moment from 'moment'

import Calendar from '../../components/Calendar/Calendar'
import AvailableHoursList from '../../components/AvailableHoursList/AvailableHoursList'

import { withStyles } from '@mui/styles'
import { style } from 'styles'

function ReservationDate({ classes }) {
	const navigate = useNavigate()
	const services = useSelector(state => state.services.services)

	const itemParam = useParams()['*'] // service.item_id

	const [selectedDay, setSelectedDay] = useState(moment())
	const [serviceSelected, setServiceSelected] = useState(null)

	// Load service selected
	useEffect(() => {
		const loadServiceSelected = async(service) => {
			const serviceSelected = services.filter(s => s.item_id == itemParam)
			setServiceSelected(serviceSelected[0])
		}

		loadServiceSelected()
	}, [])

	return (
		<div className={classes.page}>
			{serviceSelected && <React.Fragment>
				<h3 className={classes.pageTitle}>{serviceSelected.name}</h3>
				<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '0 auto', width: '100%', maxWidth: 500, backgroundColor: '#fff' }}>
					<Calendar selectedDay={selectedDay} setSelectedDay={setSelectedDay} serviceId={itemParam} />
					<AvailableHoursList service={serviceSelected} selectedDay={selectedDay}/>
				</div>
			</React.Fragment>}
		</div>
	)
}

export default withStyles(style)(ReservationDate)
